/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdministrationUserDetails } from '../../models/administration-user-details';
import { KeyType } from '../../models/key-type';

export interface GetAdministrationOrganizationUserV3$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;

/**
 * The user key
 */
  userKey: KeyType;
}

export function getAdministrationOrganizationUserV3(http: HttpClient, rootUrl: string, params: GetAdministrationOrganizationUserV3$Params, context?: HttpContext): Observable<StrictHttpResponse<AdministrationUserDetails>> {
  const rb = new RequestBuilder(rootUrl, getAdministrationOrganizationUserV3.PATH, 'get');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.path('userKey', params.userKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdministrationUserDetails>;
    })
  );
}

getAdministrationOrganizationUserV3.PATH = '/administration/organizations/{organizationKey}/users/{userKey}';
